// sentry-http.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import * as Sentry from '@sentry/angular';


export const SentryInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.includes('validate')) {
    return next(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0) {
          return throwError(() => error);
        }
        const errorMessage =
          error.error?.message ||
          error.error?.error ||
          error.error?.detail ||
          (typeof error.error === 'string' ? error.error : null) ||
          error.statusText ||
          'Unknown error';

        const sentryError = new Error(
          `API ${error.status} ${error.statusText}: ${request.method} ${request.url} — ${errorMessage}`
        );

        (sentryError as any).originalError = error.error;
        (sentryError as any).status = error.status;
        (sentryError as any).url = request.url;
        (sentryError as any).method = request.method;

        Sentry.captureException(sentryError, {
          tags: {
            type: 'api_error',
            status_code: String(error.status),
            api_url: request.url,
            method: request.method,
          },
          extra: {
            request_url: request.url,
            request_method: request.method,
            request_body: request.body,
            response_status: error.status,
            response_error: error.error,
            response_message: errorMessage,
            response_headers: error.headers,
          },
        });

        return throwError(() => error);
      })
    );
  } else {
    return next(request);
  }
}